import { combineReducers } from 'redux';

import sendsReceipts from './sendsReceipts';
import accountDetails from './accountDetails';
import checkout from './checkout';
import shipment from './shipment';
import selectPayment from './selectPayment';

const cartModule = combineReducers({
  sendsReceipts,
  accountDetails,
  shipment,
  checkout,
  selectPayment,
});

export default cartModule;
